/**
 * MUI v7 theme. Minimal palette + shape tweaks; component overrides
 * stay thin so we can evolve the design system without chasing
 * breaking changes across every page.
 */

import { createTheme } from '@mui/material/styles';

export const muiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0f172a' },   // slate-900
    secondary: { main: '#2563eb' }, // blue-600
    background: {
      default: '#f8fafc', // slate-50
      paper: '#ffffff',
    },
  },
  shape: { borderRadius: 8 },
  typography: {
    // Noto Sans JP first so Japanese renders crisply; fallback chain
    // covers Latin scripts with Inter / system.
    fontFamily: [
      'Inter',
      'Noto Sans JP',
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(', '),
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiPaper: { defaultProps: { elevation: 0 }, styleOverrides: { root: { border: '1px solid #e2e8f0' } } },
  },
});
